<template>
  <Card class="contract-default">
    <template #default>
      <Loader :value="hasAccess && !docLoaded" class="contract-default__preview">
        <embed
          v-if="hasAccess"
          :src="`/api/contract/${value.id}/document/${encodeURIComponent(value.title)}`"
          class="content"
          @load="docLoaded = true"
        />
        <div v-else class="content row middle center">
          <Badge theme="error" :value="$t('noAccess')" :icon="['fal', 'lock']" />
        </div>
      </Loader>
    </template>
    <template v-if="!['accepted', 'declined'].includes(value.status)" #footer>
      <template v-if="value.acceptUrl">
        <Alert class="pull-left" theme="warning"> {{ $t('contractApprovalWarning') }} </Alert>
        <ButtonComponent :label="$t('accept')" theme="success" :icon="['fal', 'check-circle']" @click="onAcceptClick" />
        <ButtonComponent :label="$t('decline')" theme="error" :icon="['fal', 'times']" @click="$emit('decline')" />
      </template>
      <template v-else>
        <div class="row middle">
          <FontAwesomeIcon :icon="['fal', 'exclamation-triangle']" class="mr-2 text--warning" size="lg" />
          <div>{{ footerLabel }}</div>
        </div>
      </template>
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Card'
import { AlertComponent as Alert } from 'vue-elder-alert'
import Badge from '@/components/Badge'

export default {
  props: {
    value: Object,
    hasAccess: Boolean,
  },
  data() {
    return {
      docLoaded: false,
    }
  },
  computed: {
    footerLabel() {
      if (this.value.status === 'draft') return this.$t('contractNotSentForSigning')
      if (!this.value.canSign) return this.$t('youDoNotHaveSignAuthority')
      if (this.value.status === 'signed') return this.$t('contractBeingFinalized')
      return this.$t('contractAwaitingSigners')
    },
  },
  methods: {
    onAcceptClick() {
      window.location.href = this.value.acceptUrl
    },
  },
  components: {
    Card,
    Alert,
    Badge,
  },
}
</script>

<style lang="scss">
.contract-default {
  .card__content {
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
  }

  .card__footer-content {
    justify-content: center;
  }

  &__preview {
    width: 100%;
    border-radius: var(--border-radius) var(--border-radius) 0 0;
    overflow: hidden;

    @include aspect-ratio(210, 257);

    .content {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
